import { default as auth } from './auth/auth.actions'
import { default as products } from './products/product.actions'

const requestActions = { auth, products }

export default requestActions
